import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiDownload, FiMail } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero section">
      <div className="hero-background">
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="container">
        <motion.div
          ref={ref}
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.div className="hero-text" variants={itemVariants}>
            <motion.h1 style={{ margin: 0, padding: 0 }} variants={itemVariants}>
              <span className="hero-greeting" style={{ display: 'block' }}>
                Hi, I'm
              </span>
              <span className="hero-name" style={{ display: 'block', fontSize: '4rem' }}>
                Gayatri Duse
              </span>
            </motion.h1>

            <motion.h2 className="hero-title" variants={itemVariants}>
              Building meaningful digital experiences
            </motion.h2>

            <motion.p className="hero-description" variants={itemVariants}>
              I'm a passionate <span className="highlight">Computer Engineering Student</span> and
              <span className="highlight"> Software Developer</span> who loves creating
              innovative solutions and building impactful technology that makes a difference.
            </motion.p>

            <motion.div className="hero-actions" variants={itemVariants}>
              <motion.a
                href="/resume.pdf"
                className="btn btn-primary"
                download
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FiDownload />
                Download Resume
              </motion.a>

              <motion.button
                className="btn btn-secondary"
                onClick={scrollToContact}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FiMail />
                Contact Me
              </motion.button>
            </motion.div>
          </motion.div>

          <motion.div className="hero-image" variants={itemVariants}>
            <motion.div
              className="image-container"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src="/image.png"
                alt="Gayatri Duse"
                className="profile-image"
              />
              <div className="image-border"></div>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>

      <motion.div
        className="scroll-indicator"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.5, duration: 0.6 }}
      >
        <div className="scroll-line"></div>
        <div className="scroll-text">Scroll Down</div>
      </motion.div>
    </section>
  );
};

export default Hero;